<template lang="html">
    <div class="section-overly">
      <div class="outer-text">
        <div class="middle-text">
          <div class="inner-text">
            <div class="modal-wrap login-page">
              <div class="modal-bodies">
                <div class="row modal-body">
                  <div class="col-lg-5 col-md-6 col-sm-6 col-xs-12 no-padding">
                    <div class="login-wrap">
                      <div class="login-header">
                        <img :src="Logo" class="img-responsive" alt="">
                      </div>
                      <div class="login-form" v-if="!resetPasswordResponse">
                        <form>
                          <h3 class="inputtitle mb-5">RESET YOUR PASSWORD</h3>
                          <div class="input-group" v-if="reason">
                            <label>{{ reason }}</label>
                          </div>
                          <div class="input-group mt-20">
                            <input type="password" autocomplete="off" v-model.trim.lazy="password" placeholder="**********" />
                              <div class="msglength" v-if="$v.password.$dirty && !$v.password.strongPassword">
                              <span class="msglength-text">
                                At least one <span class="msgerror">special character, uppercase</span> and <span class="msgerror">number</span></span>
                            </div>
                            <label>New Password</label>
                          </div>

                          <div class="input-group">
                            <input type="password" autocomplete="off"
                            v-model.trim.lazy="repeatPassword" placeholder="**********" />
                            <label>CONFIRM PASSWORD</label>
                            <div class="msglength" v-if="$v.repeatPassword.$dirty && !$v.repeatPassword.sameAsPassword">
                              <span class="msglength-text msgerror">Passwords doesn't match.</span>
                            </div>
                          </div>

                          <div class="row col-lg-12
                            col-md-12
                            col-sm-12
                            col-xs-12
                            no-padding
                            footer-section">
                            <div class="col-lg-12
                              col-md-6
                              col-sm-6
                              col-xs-12
                              no-padding
                              dspl_inlineblock">
                              <div class="button-style">
                                <button type="button" @click="changePassword" required class="primary-btn login-btn">
                                      RESET PASSWORD
                                </button>
                              </div>
                            </div>
                          </div>

                          <div class="msglength mt-40" v-if="!$v.password.minLength">
                            <span class="msglength-text msgerror">
                              Password must be minimum of 8 chars
                            </span>
                          </div>
                          <div class="msglength mt-40" v-if="errorMessage">
                            <span class="msglength-text msgerror">
                              {{errorMessage}}
                            </span>
                          </div>
                        </form>

                        <!-- <form>
                          <h3 class="inputtitle">FORGOT PASSWORD</h3>
                          <div class="input-group">
                            <input type="text" required v-model="userEmail">
                            <label>Enter registered email address</label>
                            <span class="error" v-if="!$v.userEmail.email">Email is incorrect</span>
                          </div>
                          <div class="row col-lg-12
                            col-md-12
                            col-sm-12
                            col-xs-12
                            no-padding
                            footer-section">
                            <div class="col-lg-5
                              col-md-6
                              col-sm-6
                              col-xs-12
                              no-padding
                              dspl_inline">
                              <div class="forgot-pswd">
                                <h4>Back to login</h4>
                              </div>
                            </div>
                            <div class="col-lg-7
                              col-md-6
                              col-sm-6
                              col-xs-12
                              no-padding
                              dspl_inlineblock">
                              <div class="button-style">
                                <button type="button" class="primary-btn">
                                    SEND RESET LINK
                                </button>
                              </div>
                            </div>
                          </div>
                        </form> -->
                      </div>
                      <div class="login-form reset" v-else>
                        <h3 class="inputtitle text-md">PASSWORD RESET SUCCESSFUL</h3>
                        <div class="login-info text-left">
                          Your password has been updated successfully.Please login with your new password.
                        </div>
                          <div class="col-lg-6
                            col-md-6
                            col-sm-6
                            col-xs-12
                            no-padding mt-20">
                            <div class="button-style f-left">
                              <button type="button" @click="viewLoginScreen" class="primary-btn login-btn">
                                  LOGIN
                              </button>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-7 col-md-6 col-sm-6 col-xs-12 no-padding">
                    <div class="radius-right" style="height: 100%;">
                      <img src="@common/asset/images/Sign_In.jpg" class="img-responsive" alt="" style="border-radius:0 14px 14px 0px; height: 100%;">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Logo from '@common/asset/images/logo.svg';
import Bg from '@common/asset/images/Sign_In.jpg';
import { helpers, required, sameAs, minLength } from 'vuelidate/lib/validators';
import { passwordPattern } from 'pando-constants';

const strongPassword = helpers.regex('strongPassword', passwordPattern);

export default {
  data() {
    return {
      Logo,
      Bg,
      password: null,
      repeatPassword: null,
    };
  },
  props: {
    reason: {
      type: String,
      default: '',
    },
    resetPasswordResponse: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
      strongPassword,
    },

    repeatPassword: {
      sameAsPassword: sameAs('password'),
    },
    isValidPass: ['password', 'repeatPassword'],
  },
  methods: {
    async changePassword() {
      this.$v.isValidPass.$touch();
      if (this.$v.isValidPass.$anyDirty && this.$v.isValidPass.$invalid) {
        return;
      }
      const password = this.password;
      const data = { password };
      this.$emit('changePassword', data);
    },
    viewLoginScreen() {
      this.$emit('viewLoginScreen', '');
    },
  },
};
</script>

<style lang="scss">
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

#header {
    width: 100%;
    padding: 0;
    float: left;
    height: 100vh;
}
.parallaxbg {
    background-image: url(~@common/asset/images/login_bg.jpg);
    // margin: -120px -20px -20px -20px !important;
    width: 100%;
    margin: 0 auto;
    background-position: center center;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    overflow: hidden;
}
.section-overly {
    min-height: 100vh;
    .no-padding {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    .dspl_inline {
        display: inline;
    }
    .dspl_inlineblock {
        display: inline-block;
    }
    .inputtitle {
      width: 100%;
      margin-bottom: 25px;
      font-size: 1.4rem;
      color: #005399;
      text-align: left;
    }
    .outer-text {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
    }
    .middle-text {
        display: table;
        width: 100%;
        height: 100%;
    }
    .inner-text {
        display: table-cell;
        vertical-align: middle;
    }
    form {
        input {
            width: 100%;
            border: 0;
            border-bottom: 1px solid #9B9B9C;
            padding: 12px 0 9px;
            font-family:$fontSemibold;
            font-size: 12px;
            color: #404040;
            height:34px;
            &:focus {
                outline: none;
                border-color: #008AFF;
            }
        }
        .input-group {
            position: relative;
            width: 100%;
            margin: 10px 0 20px;
            label {
                content: attr(data-placeholder);
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                -webkit-transform: translate(0%, -50%);
                transform: translate(0%, -50%);
                -webkit-transition: all 0.3s ease-in-out;
                transition: all 0.3s ease-in-out;
                background-color: rgba(255, 255, 255, 0);
                color: #404040;
                font-size: 10px;
                font-weight: normal;
                line-height: 10px;
                text-transform: uppercase;
                input[type="text"],
                input[type="password"] {
                    border-bottom: 1px solid #9999a3;
                }
                input[type="text"]:focus,
                input[type="text"]:valid,
                input[type="password"]:focus,
                input[type="password"]:valid {
                    border-bottom: 1px solid #9B9B9C;
                }
                input:focus~label,
                input:valid~label {
                    top: -1px;
                    color: #404040;
                    font-size: 10px;
                    font-weight: normal;
                    line-height: 10px;
                    text-transform: uppercase;
                }
            }
        }
    }
    .modal-wrap {
        max-width: 1000px;
        margin: 0 auto;
        border-radius: 10px;
        box-shadow: 3px 3px 10px 0 #01314f;
        -webkit-transition: -webkit-transform 300ms ease-in-out;
        transition: -webkit-transform 300ms ease-in-out;
        transition: transform 300ms ease-in-out;
        transition: transform 300ms ease-in-out, -webkit-transform 300ms ease-in-out;
        .modal-bodies {
            position: relative;
            -webkit-perspective: 1000px;
            perspective: 1000px;
        }
    }
    .login-page form {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .login-wrap {
        box-shadow: 5px 0 10px 1px rgba(0, 0, 0, 0.1);
        background: #fff;
        border-radius: 4px 0px 0px 4px;
        height: 528px;
        .login-header {
            padding: 30px 20px 20px 30px;
            text-align: left;
        }
        .login-form {
            padding: 45px;
        }
        .border-line {
          border: 2px solid #008AFF;
          float: left;
          width: 47px;
          margin: 0 30px;
        }
    }
    .footer-section {
        margin: 10px 0;
        .forgot-pswd h4 {
          float: left;
          margin: 0;
          color: #008AFF;
          font-size: 1.0rem;
          line-height: 26px;
          cursor: pointer;
        }
    }
    .button-style {
        text-align: right;
        .primary-btn {
            cursor: pointer;
            background-color: #008AFF;
            color: #fff;
            border-color: #008AFF;
            border-radius: 2px;
            padding: 7px 10px;
            text-transform: uppercase;
            font-size: 1.0rem;
            font-weight: normal;
            white-space: nowrap;
            outline: none;
        }
    }
    .conditions {
        padding: 0 50px 30px;
        vertical-align: bottom;
        position: relative;
        h5 {
            color: #008AFF;
            font-family:$fontSemibold;
            font-size: 10px;
            text-align: left;
        }
        p {
            color: #929292;
            font-size: 9px;
            letter-spacing: 0.23px;
            text-align: left;
        }
    }
    .error {
        display: block;
        color: #E8655D;
        font-size: 15px;
        margin: 10px;
    }
}
.radius-right {
  line-height: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.login-btn {
  background-color: #077D8A !important;
  border: 1px solid #077D8A !important;
  border-radius: 4px !important;
}
.msglength {
    margin-top: 10px;
    &-text {
        font-size: 10px;
        color: #5A6277;
        float: left;
    }
    &-character {
        font-size: 10px;
        color: #5A6277;
        float: right;
    }
}
.msg-content {
    color: #5A6277;
    font-size: 12px;
    text-align: left;
    line-height: 18px;
}
.floatleft {
    float: left !important;
}
.msgerror{
  color:#D12424;
}
.button-style button:disabled{
  opacity: .2;
}
.mt-40 {
  margin-top: 40px;
}
</style>
